export const projects = [
  {
    name: 'simpleVue',
    desc: '简化版 Vue 实现，帮助理解响应式与虚拟 DOM 原理。',
    stars: 27,
    lang: 'JavaScript',
    url: 'https://github.com/YuFy1314/simpleVue',
    demo: 'https://yufy1314.github.io/simpleVue/',
    featured: true,
  },
  {
    name: 'my-mailefengle-gallery',
    desc: 'Vue 全家桶 + Webpack 移动端画廊，可打包为 App。',
    stars: 9,
    lang: 'Vue',
    url: 'https://github.com/YuFy1314/my-mailefengle-gallery',
    demo: 'https://yufy1314.github.io/my-mailefengle-gallery/',
    featured: true,
  },
  {
    name: 'resume',
    desc: '个人在线简历站点，持续维护的职业档案。',
    stars: 0,
    lang: 'CSS',
    url: 'https://github.com/YuFy1314/resume',
    demo: 'https://yufy1314.github.io/resume/',
    featured: true,
  },
  {
    name: 'ai-coding-rules',
    desc: 'AI 编程助手指令集，提升代码质量与协作效率。',
    stars: 0,
    lang: 'MIT',
    url: 'https://github.com/YuFy1314/ai-coding-rules',
    demo: null,
    featured: true,
  },
  {
    name: 'vue-cli-demo',
    desc: 'Vue-cli + Element + Less 入门示例，适合新手快速上手。',
    stars: 2,
    lang: 'JavaScript',
    url: 'https://github.com/YuFy1314/vue-cli-demo',
    demo: 'https://yufy1314.github.io/vue-cli-demo/',
    featured: false,
  },
  {
    name: 'my-Plugins',
    desc: '自研 Web 页面常用插件合集，开箱即用。',
    stars: 2,
    lang: 'JavaScript',
    url: 'https://github.com/YuFy1314/my-Plugins',
    demo: null,
    featured: false,
  },
];
